import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { cn } from '@/lib/utils'

const STARS = [5, 4, 3, 2, 1]

interface Props {
    star?: number
    onStarChange: (v?: number) => void
    fromDate: string
    onFromDateChange: (v: string) => void
    toDate: string
    onToDateChange: (v: string) => void
    raterInput: string
    onRaterInputChange: (v: string) => void
    withComment?: boolean
    onWithCommentChange: (v?: boolean) => void
    onReset: () => void
    hasActive: boolean
}

// Filter bar tab "Điểm của tôi". Thuần presentational — state + debounce nằm ở
// ReceivedList để không phải đồng bộ hai chiều bằng useEffect.
const ReceivedFilters = ({
    star,
    onStarChange,
    fromDate,
    onFromDateChange,
    toDate,
    onToDateChange,
    raterInput,
    onRaterInputChange,
    withComment,
    onWithCommentChange,
    onReset,
    hasActive,
}: Props) => {
    const { t } = useTranslation('rating')

    return (
        <div className="space-y-2 rounded-lg border border-gray-200 bg-gray-50/60 p-3">
            {/* <label> bọc luôn <Input>: liên kết ngầm, khỏi phải phát sinh id —
                bấm vào nhãn là focus đúng ô. */}
            <div className="flex flex-wrap items-end gap-2">
                <label className="min-w-[180px] flex-1">
                    <span className="mb-1 block text-xs text-gray-500">
                        {t('filter.rater')}
                    </span>
                    <Input
                        type="search"
                        value={raterInput}
                        placeholder={t('filter.rater_placeholder')}
                        onChange={(e) => onRaterInputChange(e.target.value)}
                    />
                </label>
                <label>
                    <span className="mb-1 block text-xs text-gray-500">
                        {t('filter.from_date')}
                    </span>
                    <Input
                        type="date"
                        value={fromDate}
                        max={toDate || undefined}
                        onChange={(e) => onFromDateChange(e.target.value)}
                    />
                </label>
                <label>
                    <span className="mb-1 block text-xs text-gray-500">
                        {t('filter.to_date')}
                    </span>
                    <Input
                        type="date"
                        value={toDate}
                        min={fromDate || undefined}
                        onChange={(e) => onToDateChange(e.target.value)}
                    />
                </label>
            </div>

            <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
                <div className="flex items-center gap-1">
                    <span className="mr-1 text-xs text-gray-500">
                        {t('filter.star')}:
                    </span>
                    {STARS.map((s) => (
                        <button
                            key={s}
                            type="button"
                            aria-pressed={star === s}
                            className={cn(
                                'rounded border px-2 py-0.5 text-xs transition-colors',
                                star === s
                                    ? 'border-yellow-400 bg-yellow-50 font-medium text-yellow-700'
                                    : 'border-gray-200 text-gray-500 hover:border-gray-300'
                            )}
                            // Bấm lại chính mức đang chọn = bỏ lọc.
                            onClick={() =>
                                onStarChange(star === s ? undefined : s)
                            }
                        >
                            {s}★
                        </button>
                    ))}
                </div>

                <div className="flex items-center gap-1">
                    <span className="mr-1 text-xs text-gray-500">
                        {t('filter.comment')}:
                    </span>
                    {[
                        {
                            key: 'yes',
                            val: true,
                            label: t('filter.has_comment'),
                        },
                        {
                            key: 'no',
                            val: false,
                            label: t('filter.no_comment'),
                        },
                    ].map((o) => (
                        <button
                            key={o.key}
                            type="button"
                            aria-pressed={withComment === o.val}
                            className={cn(
                                'rounded border px-2 py-0.5 text-xs transition-colors',
                                withComment === o.val
                                    ? 'border-primary bg-primary/10 font-medium text-primary'
                                    : 'border-gray-200 text-gray-500 hover:border-gray-300'
                            )}
                            onClick={() =>
                                onWithCommentChange(
                                    withComment === o.val ? undefined : o.val
                                )
                            }
                        >
                            {o.label}
                        </button>
                    ))}
                </div>

                {hasActive && (
                    <Button
                        variant="ghost"
                        size="sm"
                        className="ml-auto h-7 text-xs"
                        onClick={onReset}
                    >
                        {t('filter.reset')}
                    </Button>
                )}
            </div>
        </div>
    )
}

export default ReceivedFilters
